import { css } from 'styled-components';
import { colorCSS } from './colors';
import { breakpoints } from './breakpoints';
import { fontSizes } from './textSize';
// to style UiMarkdown and UiTextBlock consistently
export const blockquoteCSS = css `
  blockquote {
    display: inline-block;
    font-size: ${fontSizes.lg};
    line-height: 1.5;
    margin-bottom: 1rem;
    > * {
      margin-top: 1rem;
      margin-left: 4.5rem;
      margin-right: 1rem;

      @media (max-width: ${breakpoints.sm}px) {
        margin-top: 0.7rem;
        margin-left: 4rem;
        margin-bottom: 1rem;
      }
    }
    &::before {
      position: absolute;
      color: ${colorCSS('T400')};
      content: '“';
      font-weight: 300;
      font-size: 6.5rem;
      margin-top: -0.8rem;

      @media (max-width: ${breakpoints.sm}px) {
        font-size: 5.5rem;
        margin-top: -1rem;
      }
    }
  }
`;
//# sourceMappingURL=blockquote.js.map